import { atom } from "recoil";
import { ocPersistAtom } from "oc/states/persist-atom";

export const myCafeteriaShowNewStatementItemInlineFormState = atom({
  key: "myCafeteriaShowNewStatementItemInlineFormState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
